import { autoScrollForElements } from "@atlaskit/pragmatic-drag-and-drop-auto-scroll/element";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";

import { WorkoutItemsRoot } from "src/components/WorkoutItemsRoot";
import { WorkoutModalBase } from "src/components/WorkoutModalBase";
import { useUpdateWorkout } from "src/workouts/useUpdateWorkout";

export const SectionEditWorkoutItems = observer(
  function SectionEditWorkoutItems() {
    const scrollRef = useRef<HTMLDivElement>(null);

    useUpdateWorkout();

    useEffect(() => {
      if (!scrollRef.current) {
        return;
      }

      return autoScrollForElements({ element: scrollRef.current });
    }, []);

    return (
      <WorkoutModalBase
        contentRef={scrollRef}
        contentClassName="w-full max-w-[800px] px-5 py-4 lg:pl-10"
        workoutItems={<WorkoutItemsRoot />}
      />
    );
  },
);
